<template>
  <v-form class="px-2" v-model="valid" ref="timingForm">
    <h3 class="display-1 font-weight-bold">Timing</h3>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-switch
            v-model="deadline"
            label="Deadline to Participate?"
            color="success"
        ></v-switch>
        <v-radio-group v-model="startOption" column v-if="deadline" class="mt-0">
          <v-layout align-center>
            <v-radio hide-details value="dateTime" class="shrink mr-2"></v-radio>
            <v-menu
                v-model="deadlineDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="startDate"
                    label="Select a date"
                    prepend-icon="event"
                    :disabled="startOption!=='dateTime'"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate" :allowed-dates="allowedDates"
                             @input="deadlineDateMenu = false"></v-date-picker>
            </v-menu>
            <v-menu
                ref="deadlineTimeMenu"
                v-model="deadlineTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="startTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="startTime"
                    label="Select a time"
                    prepend-icon="access_time"
                    :disabled="startOption!=='dateTime'"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="deadlineTimeMenu"
                  v-model="startTime"
                  format="24hr"
                  full-width
                  @click:minute="$refs.deadlineTimeMenu.save(startTime)"
              ></v-time-picker>
            </v-menu>
          </v-layout>
          <p class="error--text v-messages" v-if="!areDatesValid">
            "Deadline to participate" must be before {{winnerDate}} {{winnerTime}}
          </p>
          <p class="error--text v-messages" v-if="!isAfterNow(startDate, startTime)">
            selected time cannot be before the current time
          </p>
          <v-radio label="manual" value="manual"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm6>
        <p class="v-label theme--light my-4 pb-1">When is the winner declared?</p>
        <v-radio-group v-model="winnerOption" column>
          <v-layout align-center>
            <v-radio hide-details value="dateTime" class="shrink mr-2"></v-radio>
            <v-menu
                v-model="winnerDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="winnerDate"
                    label="Select a date"
                    prepend-icon="event"
                    :disabled="winnerOption!=='dateTime'"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="winnerDate" :allowed-dates="allowedDates"
                             @input="winnerDateMenu = false"></v-date-picker>
            </v-menu>
            <v-menu
                ref="winnerTimeMenu"
                v-model="winnerTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="winnerTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="winnerTime"
                    label="Select a time"
                    prepend-icon="access_time"
                    :disabled="winnerOption!=='dateTime'"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="winnerTimeMenu"
                  v-model="winnerTime"
                  format="24hr"
                  full-width
                  @click:minute="$refs.winnerTimeMenu.save(winnerTime)"
              ></v-time-picker>
            </v-menu>
          </v-layout>
          <p class="error--text v-messages" v-if="!isAfterNow(winnerDate, winnerTime)">
            selected time cannot be before the current time
          </p>
          <v-radio label="manual" value="manual"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-spacer></v-spacer>
      <v-btn round color="warning" @click="submit" :disabled="!valid">next</v-btn>
    </v-layout>
  </v-form>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'instaplayForm/timing/getTimingField',
        mutationType: 'instaplayForm/timing/updateTimingField',
    });
    export default {
        name: "Timing",
        data() {
            return {
                deadlineDateMenu: false,
                deadlineTimeMenu: false,
                winnerDateMenu: false,
                winnerTimeMenu: false,
            }
        },
        computed: {
            ...mapFields([
                'deadline',
                'startOption',
                'winnerOption',
                'startDate',
                'startTime',
                'winnerDate',
                'winnerTime',
            ]),
            areDatesValid: function () {
                if (!this.startDate || !this.startTime || !this.winnerDate || !this.winnerTime)
                    return true
                return this.getDate(this.startDate, this.startTime) < this.getDate(this.winnerDate, this.winnerTime)
            },
            valid: {
                get() {
                    return (!!this.winnerDate && !!this.winnerTime || this.winnerOption !== 'dateTime')
                        && (!this.deadline || (!!this.startDate && !!this.startTime) || this.startOption !== 'dateTime')
                        && this.isAfterNow(this.winnerDate, this.winnerTime)
                        && this.isAfterNow(this.startDate, this.startTime)
                        && this.areDatesValid
                },
                set(newValue) {
                    return newValue
                }
            }
        },
        methods: {
            getDate: function (date, time) {
                date = date.split('-')
                time = time.split(':')
                let year = parseInt(date[0])
                let month = parseInt(date[1]) - 1
                let day = parseInt(date[2])
                let hour = parseInt(time[0])
                let minute = parseInt(time[1])
                return new Date(year, month, day, hour, minute)
            },
            isAfterNow: function (date, time) {
                if (!date || !time)
                    return true
                return this.getDate(date, time) > new Date()
            },
            allowedDates: (val) => new Date(
                parseInt(val.split('-')[0]),
                parseInt(val.split('-')[1]) - 1,
                parseInt(val.split('-')[2]),
                23, 59, 59, 99
            ) >= new Date(),
            submit: function () {
                this.$emit('setState', 4)
                //submit the form...
            },
            setWinnerDateTime(date, time) {
                let d = this.getDate(date, time)
                d = new Date(d.setHours(d.getHours() + 4))
                if (!this.winnerTime || !this.winnerDate || !this.areDatesValid) {
                    this.winnerTime = d.toTimeString().slice(0, 5)
                    this.winnerDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
                }
            }
        },
        watch: {
            valid: function (val) {
                this.$emit('input', val)
            },
            startDate: function (val) {
                if (val && this.startTime) {
                    this.setWinnerDateTime(val, this.startTime)
                }
            },
            startTime: function (val) {
                if (val && this.startDate) {
                    this.setWinnerDateTime(this.startDate, val)
                }
            }
        }
    }
</script>

<style scoped>

</style>
